import {Registry, RegistryPreferences} from 'constants/RegistryConstants';
import preferences from 'Preferences';

export function getInitialRegistry(registries: Array<Registry>): Registry | null {
  if (registries.length === 0) {
    return null;
  } else if (registries.length === 1) {
    return registries[0];
  } else {
    const defaultRegistryId = preferences.get(RegistryPreferences.DEFAULT_REGISTRY);
    const defaultRegistry = registries.find((registry) => registry.id === defaultRegistryId);
    // Pre-select the first registry if no default is available.
    return defaultRegistry || registries[0];
  }
}

export function setDefaultRegistry(registryId: string): void {
  preferences.set(RegistryPreferences.DEFAULT_REGISTRY, registryId);
}
